import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

const msg = (e) => e?.response?.data?.detail?.message || "Could not load your tasks.";

// B7: open project tasks assigned to me (only projects I can still see), with overdue / due-soon flags.
export default function MyTasks() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/pm/my-tasks").then((r) => setRows(r.data)).catch((e) => setErr(msg(e))), []);
  useEffect(() => { load(); }, [load]);
  const done = (id) => api.patch(`/pm/tasks/${id}`, { status: "done" }).then(load).catch((e) => setErr(msg(e)));
  return (
    <AppShell title="My tasks" subtitle="Project tasks assigned to you">
      <div className="mx-auto w-full max-w-[800px] px-4 md:px-6 space-y-3" data-testid="pm-my-tasks">
        {err && <p role="alert" className="text-sm text-red-700" data-testid="pm-my-tasks-error">{err}</p>}
        {rows && !rows.length && <p className="text-sm" data-testid="pm-my-tasks-empty">Nothing open. Nice work.</p>}
        <ul className="space-y-2">
          {(rows || []).map((t) => (
            <li key={t.id} className="border border-erf-borderCream rounded bg-white p-3 flex flex-wrap items-center gap-2" data-testid={`pm-task-${t.id}`}>
              <span className="font-semibold break-words min-w-0">{t.title}</span>
              <span className="text-xs">due {t.due_date}</span>
              {t.overdue && <span className="text-xs text-red-800 font-semibold" data-testid={`pm-task-overdue-${t.id}`}>Overdue</span>}
              {t.due_soon && <span className="text-xs text-amber-800 font-semibold" data-testid={`pm-task-soon-${t.id}`}>Due soon</span>}
              <Link to={`/pm/projects/${t.project_id}/schedule`} className="text-xs underline inline-flex min-h-[44px] items-center" data-testid={`pm-task-project-${t.id}`}>Project schedule</Link>
              <button type="button" onClick={() => done(t.id)} className="min-h-[44px] px-3 rounded-sm border border-erf-borderCream text-sm ml-auto" data-testid={`pm-task-done-${t.id}`}>Mark done</button>
            </li>
          ))}
        </ul>
      </div>
    </AppShell>
  );
}
